import { jsx as _jsx } from "react/jsx-runtime";
import DatePicker from "antd/lib/date-picker";
import "antd/lib/date-picker/style/index.js";
import { useEffect, useRef } from 'react';
import { formatMomentDate } from '../DatePicker/helpers';
import { DATE_FORMATS } from '$Utils';
const { RangePicker } = DatePicker;
const HVDateRangePicker = ({ id, value, ...props }) => {
    let startDate = value === null || value === void 0 ? void 0 : value[0];
    let endDate = value === null || value === void 0 ? void 0 : value[1];
    const rangePickerRef = useRef(null);
    useEffect(() => {
        if (rangePickerRef.current) {
            const inputs = rangePickerRef.current.querySelectorAll('input');
            if (inputs.length === 2) {
                inputs[0].id = `${id}-start`;
                inputs[1].id = `${id}-end`;
            }
        }
    }, []);
    return (_jsx("div", { ref: rangePickerRef, children: _jsx(RangePicker, { ...props, value: value
                ? [
                    formatMomentDate(startDate),
                    formatMomentDate(endDate)
                ]
                : value, format: DATE_FORMATS }) }));
};
export default HVDateRangePicker;
